const metaLayer = window.metaLayer;
const projectPath = 'bbmx/comparison-selector-mx-pdp/dist/client/';
const root = metaLayer ? (metaLayer.env_assets || '').replace(/@gvpc$/, '@bbmx') : '';
const publicPath = metaLayer ? `${root}/${projectPath}` : projectPath;

__webpack_public_path__ = publicPath; // eslint-disable-line no-undef



// WEBPACK FOOTER //
// ./client/webpack-public-path.js